import { useEtapaDuracao } from "./use-etapa-duracao";
import { EtapaDuracaoView } from "./view-etapa-duracao";

export function EtapaDuracao() {
  const vm = useEtapaDuracao();

  return <EtapaDuracaoView {...vm} />;
}

export type * from "./types-etapa-duracao";
